module.exports = __webpack_public_path__ + "static/media/Photos_top_deliveryman.4dc04bc5.png";